module.exports = __webpack_public_path__ + "img/1449788284.88863696.jpg";